import { 
  fmtIso8601AsLocalDateHrsMin
} from '../../utils/formatters';

export function fmtExecutionEndTime(value) {
  if(value && value.length>0) {
    return fmtIso8601AsLocalDateHrsMin(value);
  } else {
    return "In Progress";
  }
}
